var $Curreency,$storeCurrency;
setTimeout(function(){
 $storeCurrency = document.querySelector("[name='storeCurrnecy']").value;
 $Curreency = $storeCurrency.split("0")[0];
}, 1000);

const addRow = () => {
      let table = document.getElementById("QuickOrders");
      let row = table.insertRow(-1);
      let c1 = row.insertCell(0);
      let c2 = row.insertCell(1);
      let c3 = row.insertCell(2);
      let c4 = row.insertCell(3);
      let c5 = row.insertCell(4);
      let c6 = row.insertCell(5);
      let c7 = row.insertCell(6);
      var $trLength = document.getElementById("QuickOrders").querySelectorAll("tr").length;
      Updaterow();
      $trLength--;
    
    c1.innerHTML = "<button type='button' class='DeleteButton' onClick='DeleteRow("+ $trLength +")' data-index='"+ $trLength +"'>"+
      '<svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="[http://www.w3.org/2000/svg">](http://www.w3.org/2000/svg%22%3E)'+
              '<g clip-path="url(#clip0_763_13404)">' + 
              '<path d="M9.61212 16.0003H9.54819H3.45105H3.38712C2.70376 15.9999 2.04743 15.7341 1.55727 15.2594C1.06711 14.7847 0.78165 14.1383 0.761409 13.4573V4.96166C0.7598 4.90765 0.76908 4.85387 0.7887 4.8035C0.80832 4.75313 0.837882 4.7072 0.875632 4.66843C0.913382 4.62966 0.958553 4.59884 1.00847 4.57779C1.05839 4.55674 1.11203 4.5459 1.16623 4.5459C1.22043 4.5459 1.27407 4.55674 1.32399 4.57779C1.37391 4.59884 1.41908 4.62966 1.45683 4.66843C1.49458 4.7072 1.52414 4.75313 1.54376 4.8035C1.56338 4.85387 1.57266 4.90765 1.57105 4.96166V13.4716V13.4815C1.59765 13.9439 1.80045 14.3787 2.13797 14.6969C2.47549 15.0151 2.92222 15.1928 3.38677 15.1935C3.41355 15.1935 3.44034 15.1935 3.46712 15.1917H9.53141C9.5582 15.1917 9.58498 15.1935 9.61141 15.1935C10.0759 15.1931 10.5226 15.0158 10.8603 14.6979C11.198 14.38 11.4011 13.9456 11.4282 13.4833V13.4733V4.96344C11.4266 4.90943 11.4359 4.85565 11.4555 4.80528C11.4751 4.75491 11.5047 4.70898 11.5424 4.67021C11.5802 4.63144 11.6253 4.60062 11.6753 4.57957C11.7252 4.55852 11.7788 4.54768 11.833 4.54768C11.8872 4.54768 11.9409 4.55852 11.9908 4.57957C12.0407 4.60062 12.0859 4.63144 12.1236 4.67021C12.1614 4.70898 12.1909 4.75491 12.2105 4.80528C12.2302 4.85565 12.2394 4.90943 12.2378 4.96344V13.4591C12.2176 14.14 11.9322 14.7863 11.4421 15.2611C10.952 15.7358 10.2958 16.0016 9.61248 16.0021L9.61212 16.0003Z" fill="black"></path>' +
              '<path d="M0.405426 3.08599C0.300142 3.08287 0.200218 3.03898 0.126852 2.96363C0.0534866 2.88828 0.0124512 2.7874 0.0124512 2.68239C0.0124512 2.57738 0.0534866 2.4765 0.126852 2.40115C0.200218 2.3258 0.300142 2.28191 0.405426 2.2788H3.81043V0.403774C3.81052 0.296777 3.85317 0.194184 3.92903 0.118492C4.00488 0.0428007 4.10775 0.0001885 4.21507 0H8.7865C8.89382 0.0001885 8.99669 0.0428007 9.07254 0.118492C9.14839 0.194184 9.19104 0.296777 9.19114 0.403774V2.2788H12.5961C12.7014 2.28191 12.8013 2.3258 12.8747 2.40115C12.9481 2.4765 12.9891 2.57738 12.9891 2.68239C12.9891 2.7874 12.9481 2.88828 12.8747 2.96363C12.8013 3.03898 12.7014 3.08287 12.5961 3.08599H0.405426ZM4.61971 2.2788H8.38185V0.807193H4.61971V2.2788Z" fill="black"></path>' +
              '<path d="M4.97642 12.2015C4.86913 12.2014 4.76626 12.1589 4.6904 12.0832C4.61453 12.0076 4.57187 11.9051 4.57178 11.7981V6.48065C4.5749 6.37569 4.61893 6.27607 4.6945 6.20292C4.77008 6.12978 4.87127 6.08887 4.9766 6.08887C5.08193 6.08887 5.18312 6.12978 5.25869 6.20292C5.33427 6.27607 5.37829 6.37569 5.38142 6.48065V11.7981C5.38123 11.9051 5.33849 12.0076 5.26257 12.0833C5.18665 12.1589 5.08374 12.2014 4.97642 12.2015Z" fill="black"></path>' +
              '<path d="M8.02366 12.2015C7.91633 12.2014 7.81343 12.1589 7.73751 12.0833C7.66158 12.0076 7.61884 11.9051 7.61865 11.7981V6.48065C7.62178 6.37569 7.6658 6.27607 7.74138 6.20292C7.81696 6.12978 7.91815 6.08887 8.02348 6.08887C8.12881 6.08887 8.23 6.12978 8.30558 6.20292C8.38115 6.27607 8.42518 6.37569 8.4283 6.48065V11.7981C8.42821 11.9051 8.38555 12.0076 8.30968 12.0832C8.23381 12.1589 8.13095 12.2014 8.02366 12.2015Z" fill="black"></path>' +
              '</g>' +
              '<defs>' +
              '<clipPath id="clip0_763_13404">' +
              '<rect width="13" height="16" fill="white"></rect>' + 
              '</clipPath>' + 
              '</defs>' +
            '</svg>' + 
      "</button>";
    c2.innerHTML = "<input type='text' class='Skuinput' onkeyup='SkuInput(this)' placeholder='Enter SKU' value='' /><div class='search_results'><div class='quick_order_loader'></div></div>";
    c3.innerHTML = `<div class="number"><span class="minus">-</span><input type="number" min="1" value="" class="QtyInput"/><span class="plus">+</span></div>`;
   }
  const DeleteRow = (index) => {
    document.getElementById("QuickOrders").deleteRow(index);
    Updaterow();
  }
  const Updaterow = () => {
    var trLength = document.getElementById("QuickOrders").querySelectorAll("tr").length;
      for(i=0;i<trLength;i++){
        if(document.getElementById("QuickOrders").querySelectorAll("tr")[i].querySelector(".DeleteButton")){
          document.getElementById("QuickOrders").querySelectorAll("tr")[i].querySelector(".DeleteButton").setAttribute("onClick","DeleteRow("+ i +")");
          document.getElementById("QuickOrders").querySelectorAll("tr")[i].querySelector(".DeleteButton").setAttribute("data-index",i);
        }
      }
  }
// Above js are use for table addrow,delete row and update row
  let debounceTimer;
  const SkuInput = (e) => {
      clearTimeout(debounceTimer); // Clear the previous timer
      const $SKUvalue = e.value; // Get the current input value
  
      debounceTimer = setTimeout(() => {
          if ($SKUvalue === "") {
              e.nextElementSibling.style.display = "none"; // Hide search results if empty
          } else {
              document.querySelector(".quickorder_main_table").classList.add("search_result_open");
              SearchSKUSProduct($SKUvalue, e); // Call the API only after user stops typing
              e.nextElementSibling.style.display = "block"; // Show search results
          }
      }, 1000); // Set debounce delay to 500ms (adjust as needed)
  };
  // const SkuInput = (e) => {
  //   var $SKUvalue = e.value;
  //     if($SKUvalue == ""){
  //       e.nextElementSibling.style.display="none";
  //     }else{
  //       document.querySelector(".quickorder_main_table").classList.add("search_result_open");
  //       SearchSKUSProduct($SKUvalue,e)
  //       e.nextElementSibling.style.display="block";
  //     }
  // }
  const SearchSKUSProduct = (keyword,targateElement) => {
    const data = { sku: keyword };
    fetch('https://apps.technomate.com/technomate/api/variants-search', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        $skuResults(data.data,targateElement);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  const $skuResults = (response,targateElement) => {
    let $appendResults = targateElement.nextElementSibling;
    $appendResults.innerHTML = `<div class="quick_order_loader"></div>`;
    if(response.length > 0){
      response.forEach((value,index) => {
        $appendResults.innerHTML +=  `<div class="search-result" data-vartitle="${value.variant_title}" onClick="AddProduct(this)">	
        <div class="product_image" data-img="${value.image_url}">
           <img src="${value.image_url}" alt="result_${index}"> 
        </div>
        <div class="product_sku" data-sku="${value.sku}">${value.sku}</div>
        <div class="Product_title" data-vendor="${value.vendor}" data-title="${value.product_title}"> ${value.product_title}</div>
        <div class="pro_price" data-price="${value.price}">${$Curreency}${value.price}</div>
        <div class="Add_prduct"><a href="javascript:;" data-varid="${value.variant_id}" data-qty="${value.inventory_quantity}">Add +</a></div>
        <div class="discription" style="display:none;">${value.description}</div>
          </div>`
      })  
      $appendResults.querySelector(".quick_order_loader").remove();
    }else{
      $appendResults.innerHTML = `<h5 style="text-align:Center;font-size:18px;line-height:24px;color:#17284f;padding:20px 10px;">Please enter valid SKU!!</h5>`;
    } 
  }

  const AddProduct = (evt) => {
    let $Variant_title,$Product_title,$Variant_sku,$product_vendor,$product_var_price,$variant_id,$variant_inventory_qty,$image_url,$event_parent,$ProductExists,$Discription,$ProductInventoryStock; 
    $ProductExists = false;
    let Skuinputs = document.querySelectorAll('.Skuinput');
    $Variant_sku = evt.querySelector(".product_sku").dataset.sku;
    let currentInput = evt.closest("td").querySelector(".Skuinput");
    Skuinputs.forEach(input => {
        if (input !== currentInput) {
           if (input.value.trim() == $Variant_sku) {
              $ProductExists = true;
            }
        }
    });
    if($ProductExists == false){
      $Variant_title = evt.dataset.vartitle;
      $Product_title = evt.querySelector(".Product_title").dataset.title;
      $product_vendor = evt.querySelector(".Product_title").dataset.vendor;
      $product_var_price = evt.querySelector(".pro_price").dataset.price;
      $variant_id = evt.querySelector(".Add_prduct a").dataset.varid;
      $variant_inventory_qty = Number(evt.querySelector(".Add_prduct a").dataset.qty);
      if($variant_inventory_qty > 99){
        $ProductInventoryStock = `<span style="color:green;"><p>99+</p> in stocks</span>`;
      }else{
        if($variant_inventory_qty < 11){
          $ProductInventoryStock = `<span style="color:green;"><p>Only ${$variant_inventory_qty}</p> in stocks</span>`;
        }else{
          $ProductInventoryStock = `<span style="color:green;"><p>${$variant_inventory_qty}</p> in stocks</span>`;
        }
      }
      if ($Product_title.includes($product_vendor)) {
        $Product_title = $Product_title.replace($product_vendor, '').trim();
    }
      $image_url = evt.querySelector(".product_image").dataset.img;
      $event_parent = evt.parentElement.parentElement;
      $Discription = evt.querySelector(".discription").innerHTML;
      $event_parent.querySelector("input.Skuinput").value = $Variant_sku;
      $event_parent.querySelector("input.Skuinput").setAttribute("data-variant",$variant_id)
      $event_parent.nextElementSibling.querySelector("input").value = 1;
      $event_parent.nextElementSibling.nextElementSibling.innerHTML = `<span style="font-weight:600;">${$product_vendor}</span> ${$Product_title}`;
      $event_parent.nextElementSibling.nextElementSibling.nextElementSibling.innerHTML = `<span class="Quick-orderPrice" data-price='${$product_var_price}'><span>${$Curreency}</span><span class="QuickOrderPrice">${$product_var_price}</span><span class="QuickOrderTextVat">ex.VAT</span></span>`;
      $event_parent.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.innerHTML = $ProductInventoryStock ;
      $event_parent.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.innerHTML = $Discription;
      evt.parentElement.style.display = "none";
      document.querySelector(".quickorder_main_table").classList.remove("search_result_open");
    }else{
      document.querySelector(".quickorder_main_table").classList.remove("search_result_open");
      alert("this product is already added to the order")
    }
    
  }


const addToBasket = () => {
  var formData = {
    'items':[]
  };
  
  document.querySelectorAll(".Skuinput").forEach((evt) => {
    var $VariantID = Number(evt.dataset.variant);
    var Qty = Number(evt.parentElement.nextElementSibling.querySelector(".QtyInput").value);
    if($VariantID){
      var Data = {'id':$VariantID,'quantity':Qty};
      formData.items.push(Data)
    }
  })
  console.log("formData-->",formData)
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
  document.querySelectorAll(".Skuinput").forEach((evt) => {
    evt.value = "";
    evt.removeAttribute("data-variant");
    evt.parentElement.nextElementSibling.querySelector(".QtyInput").value = 1;
  });

  window.location = window.routes.cart_url;
  return response.json();
})
  .catch((error) => {
    console.error('Error:', error);
  });
  
}


document.body.addEventListener("click", function (e) {
  const opened = document.querySelector(".quickorder_main_table.search_result_open");
  if (!opened) return;

  if (e.target.closest(".search_results") || e.target.closest(".Skuinput")) return;

  document.querySelectorAll(".search_results").forEach((evt) => {
    evt.style.display = "none";
  });

  opened.classList.remove("search_result_open");
});


$(document).ready(function(){
  
  $(document).on("click",".minus",function(){
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) - 1;
      count = count < 0 ? 0 : count;
      $input.val(count);
      $input.change();
      return false;
  });
  $(document).on("click",".plus",function(){
      var $input = $(this).parent().find('input');
      $input.val(parseInt($input.val()) + 1);
      $input.change();
      return false;
  });
})
  
  